// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"273":"31e62301821be174acc2","702":"ba1817873e9733f4d440","715":"105a3ef34e90b51b3ea4"}[chunkId] + ".css";
};